module.exports = __webpack_public_path__ + "static/media/room_manager_arrow_left.59607dc5.svg";